import script from "./SimCardList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimCardList.vue?vue&type=script&setup=true&lang=ts"

import "./SimCardList.vue?vue&type=style&index=0&id=4450ae08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4450ae08"]])

export default __exports__